import { render, staticRenderFns } from "./ItsOrderConsume.vue?vue&type=template&id=8d283f9e&scoped=true&"
import script from "./ItsOrderConsume.vue?vue&type=script&lang=js&"
export * from "./ItsOrderConsume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d283f9e",
  null
  
)

export default component.exports